import { useQuery } from '@tanstack/react-query';

export interface RaynetUser {
  id: number;
  raynet_id: number;
  person_id?: number;
  username: string;
  full_name: string;
  email?: string;
  user_role_name?: string;
  is_active: boolean;
  is_available_for_forms: boolean;
  last_sync_at: string;
  created_at: string;
  updated_at: string;
}

export interface RaynetUsersStats {
  total: number;
  active: number;
  available: number;
  lastSync: string | null;
}

// Hook pro načtení všech Raynet uživatelů (admin)
export function useRaynetUsers() {
  return useQuery<{ success: boolean; data: RaynetUser[] }>({
    queryKey: ['raynet-users'],
    queryFn: async () => {
      const response = await fetch('/api/admin/raynet-users');
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      return response.json();
    },
    staleTime: 5 * 60 * 1000, // 5 minut
    retry: 2,
  });
}

// Hook pro načtení dostupných Raynet uživatelů (pro formuláře)
export function useAvailableRaynetUsers() {
  return useQuery<{ success: boolean; data: RaynetUser[] }>({
    queryKey: ['raynet-users', 'available'],
    queryFn: async () => {
      const response = await fetch('/api/raynet-users/available');
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      return response.json();
    },
    staleTime: 10 * 60 * 1000, // 10 minut
    retry: 2,
  });
}

// Hook pro statistiky Raynet uživatelů
export function useRaynetUsersStats() {
  return useQuery<{ success: boolean; data: RaynetUsersStats }>({
    queryKey: ['raynet-users', 'stats'],
    queryFn: async () => {
      const response = await fetch('/api/admin/raynet-users/stats');
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      return response.json();
    },
    staleTime: 5 * 60 * 1000, // 5 minut
    retry: 2,
  });
} 